export default __webpack_public_path__ + "static/media/cardGameplay.22dab044.png";